import { Box, Select, MenuItem } from '@mui/material';
import type { GridFilterItem } from '@mui/x-data-grid-premium';

const STATUS_OPTIONS = [
  { value: 'INCOMPLETE', label: 'INCOMPLETE' },
  { value: 'COMPLETE', label: 'COMPLETE' }
];

type StatusFilterInputProps = {
  item: GridFilterItem;
  applyValue: (value: GridFilterItem) => void;
};

export const StatusFilterInput = (props: StatusFilterInputProps) => {
  return (
    <Box sx={{ p: 1, minWidth: 150, marginTop: '9px' }}>
      <Select
        value={props.item.value || ''}
        onChange={e =>
          props.applyValue({ ...props.item, value: e.target.value })
        }
        size="small"
        fullWidth
        displayEmpty
        sx={{
          '& .MuiSelect-select': {
            py: 0.5
          }
        }}
      >
        {STATUS_OPTIONS.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
